import { HTMLAttributes } from 'react'
import styled from 'styled-components'

export type TFadeProps = {
  opacity?: string | number
} & HTMLAttributes<HTMLDivElement>

export const Fade = styled.div<TFadeProps>`
  opacity: ${(props) => props.opacity || '0.7'};
  transition-duration: 300ms;
  &:hover {
    opacity: 1;
  }
`
